import { ActionCreators } from 'redux-undo'

export default (dis, store, client) => {
  return {
    undo: () => dis(ActionCreators.undo()),
    redo: () => dis(ActionCreators.redo())
  }
}
